import type { LoginMode } from '@/config/deployment/deployment.types';
import { isOidcTokenValid } from './oidc';

/** Returns the local login page for login modes that do not redirect to OIDC. */
export function getLoginPath(mode: LoginMode): '/login/account' | '/login/sso' {
  return mode === 'saml' ? '/login/sso' : '/login/account';
}

/** Preserve OIDC's JWT expiry check while keeping opaque SAML tokens API-validated. */
export function isLoginTokenValid(mode: LoginMode, token: string | null): boolean {
  return mode === 'oidc' ? isOidcTokenValid(token) : Boolean(token);
}
